import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { FiAlignRight, FiXCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { checkadmin } from "../Redux/FAQSlice";
import "./Navbarmenu.css";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import axios from "axios";
import { baseUrl } from "../Constant";

const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const dispatch = useDispatch();

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  const allowedUsersForContibution = [
    "aluru.akash",
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "uma.rani.battu",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "lavanya.umesh",
    "shramika.s.ambolkar",
    "d.d.choudhary",
    "varsha.a.tyagi",
    "akash.e.tyagi",
    "shubham.i.tyagi",
    "potnuru.sandeep"
  ];

  const hide = () => setisMenu(false);

  useEffect(() => {
    if (activeAccount) {
      loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

      dispatch(checkadmin(loggedInEnterpriseId));
    }
  }, []);

  let isUSerPresent = useSelector((state) => state.faq.isAdminPresent);

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };

  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);
  const [temp,setTemp] = useState("")

  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };
  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }
  useEffect(()=>{
    const homeUrl = async()=>{
      const result = await axios.get(`${baseUrl}/homeUrl`)
      const {data:{Url}} = result
      setTemp(Url);
    }
    homeUrl()
  },[])
  const poerbiurl =
    "https://app.powerbi.com/groups/d0c351b9-4664-4f03-8788-54c480f4c174/reports/550afd92-0a00-4079-b965-be60f1fb6923/ReportSection536e1c70b95ea882ed00?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi";

  return (
    <header className="header__middle">
      <div className="head-container">
        <div className="row-fluid">
          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiXCircle />
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    <FiAlignRight />
                  </span>
                </>
              )}
              <ul className={boxClass.join(" ")}>
                {/* <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    target="_blank"
                    href={temp?temp:""}
                  >
                    L&TT Home
                  </a>
                </li> */}
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/home`}
                  >
                    Home
                  </NavLink>
                </li>
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    aria-expanded="false"
                    aria-haspopup="true"
                    tabindex="0"
                    onClick={hide}
                    href="/home#DimensionofLearning"
                  >
                    Dimensions of Learning
                    {/* <span>
                      <FiChevronDown />
                    </span> */}
                  </a>
                  {/* <ul className={boxClassSubMenu.join(" ")}>
                    <li className="sub__menus__arrows2" onClick={hide}>
                      <a
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        // to="/SapMM"
                        href="/home#DimensionofLearning"
                      >
                        {" "}
                        Wave 1 <FiChevronRight />{" "}
                      </a>{" "}
                      <ul className="sub__menus22">
                        <li onClick={toggleClass}>
                          <a
                            className="nav-links"
                            to="/genAI"
                            href="https://atci.lkm.delivery.accenture.com/TT/Automation/genAI"
                            target="_blank"
                          >
                            {" "}
                            Gen AI{" "}
                          </a>
                        </li>
                        <li onClick={toggleClass}>
                          <a
                            className="nav-links"
                            to="/industry"
                            href="https://atc.cop.accenture.com/"
                            target="_blank"
                          >
                            {" "}
                            Industry{" "}
                          </a>
                        </li>
                        <li onClick={toggleClass}>
                          <a
                            className="nav-links"
                            to="/delivery"
                            href="https://atci.lkm.delivery.accenture.com/DLF/ATC-GN-DFA/"
                            target="_blank"
                          >
                            {" "}
                            Delivery{" "}
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className="sub__menus__arrows0" onClick={hide}>
                      <a
                        onClick={toggleClass}
                        activeClassName="is-active"
                        className="nav-links"
                        // to="/API-Automation-Testing"
                        href="/home#waveTwo"
                      >
                        {" "}
                        Wave 2 <FiChevronRight />{" "}
                      </a>{" "}
                      <ul className="sub__menus20">
                        <li onClick={toggleClass}>
                          <NavLink className="nav-links" to="/projectmonarch">
                            {" "}
                            ATC - USA{" "}
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                  </ul> */}
                </li>
                {/* <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/projectmonarch`}
                  >
                    Project Monarch
                  </NavLink>
                </li> */}
                <li className="menu-item new-badge-container">
                  <img src={process.env.PUBLIC_URL + "/images/new-icon.png"} alt="New" className="new-icon" />
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to="/aiacademy"
                  >
                    AI Academy
                  </NavLink>
                </li>
                 <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={"/LearningCalendar"}
                  >
                   Training Calendar
                  </NavLink>
                </li>
                <li className="menu-item">
                  <a
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    target="_blank"
                    href="https://atcgn.lkm.accenture.com/ATCGNCatalog/CourseCatalog"
                  >
                    Course Catalog
                  </a>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={"/dashboard"}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={"/meettheteam"}
                  >
                    Meet the Team
                  </NavLink>
                </li>

                {/* <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/sponsors`}
                  >
                    Sponsors
                  </NavLink>
                </li> */}
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/faq`}
                  >
                    FAQs
                  </NavLink>
                </li>
                {/* <li className="menu-item">
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={`/feedback`}
         >
          Feedback
         </NavLink>
        </li> */}
                <li className="menu-item">
                  <NavLink
                    activeClassName="is-active"
                    className="nav-links"
                    onClick={toggleClass}
                    to={`/ContactUs`}
                  >
                    Contact Us
                  </NavLink>
                </li>
                {/* <li className="menu-item">
                  <a
                    exact
                    activeClassName="is-active"
                    className="nav-links"
                    href="https://app.powerbi.com/groups/me/reports/05a5be12-70ea-49c4-bf8e-9077cabd8625/59b78b0f11a5771d0820?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Dashboard
                  </a>
                </li> */}
                {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                  <li
                    onClick={toggleSubmenu}
                    className="menu-item sub__menus__arrows"
                  >
                    <a
                      activeClassName="is-active"
                      className="nav-links"
                      aria-expanded="false"
                      aria-haspopup="true"
                      tabindex="0"
                      onClick={hide}
                      href="javascript:void(0)"
                    >
                      Admin
                      <span>
                        <FiChevronDown />
                      </span>{" "}
                    </a>
                    <ul className="sub__menus1">
                      <li className="sub__menus__arrows2" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to={`/analytics`}
                        >
                          Analytics
                        </NavLink>{" "}
                      </li>
                      <li className="sub__menus__arrows0" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          // to="/API-Automation-Testing"
                          to="/reviews"
                        >
                          Feedback
                        </NavLink>{" "}
                      </li>
                      <li className="sub__menus__arrows0" onClick={hide}>
                        <a
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          // to="/API-Automation-Testing"
                          href="https://atcgn.lkm.accenture.com/ATCGNCatalogAutomation/" target="_blank"
                        >
                          Course Catalog Repository
                        </a>
                      </li>
                      {/* <li className="sub__menus__arrows0" onClick={hide}>
                        <NavLink
                          onClick={toggleClass}
                          activeClassName="is-active"
                          className="nav-links"
                          to={`/admin`}
                        >
                          Add Admin
                        </NavLink>{" "}
                      </li> */}
                    </ul>
                  </li>
                )}
                {/* {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                  <li className="menu-item">
                    <NavLink
                      activeClassName="is-active"
                      className="nav-links"
                      onClick={toggleClass}
                      to={`/admin`}
                    >
                      Admin
                    </NavLink>
                  </li>
                )} */}
                {/* <li className="menu-last-item">
                  <a
                    href="https://apps.powerapps.com/play/e/default-e0793d39-0939-496d-b129-198edd916feb/a/a717c9aa-f39d-4070-bdb5-e1e3d6fd50b4?tenantId=e0793d39-0939-496d-b129-198edd916feb&sourcetime=1732794644453&source=portal#"
                    className="nav-links-register-btn"
                    onClick={toggleClass}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Looking for Learning? Raise request
                  </a>
                </li> */}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbarmenu;
